"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FollowWechatRequest = void 0;
var FollowWechatRequest = /** @class */ (function () {
    function FollowWechatRequest() {
    }
    return FollowWechatRequest;
}());
exports.FollowWechatRequest = FollowWechatRequest;
;
//# sourceMappingURL=followWechat.request.js.map